module.exports = {"420323100":"城关镇","420323101":"溢水镇","420323102":"麻家渡镇","420323103":"宝丰镇","420323104":"擂鼓镇","420323105":"秦古镇","420323106":"得胜镇","420323107":"上庸镇","420323108":"官渡镇","420323200":"潘口乡","420323201":"竹坪乡","420323202":"大庙乡","420323203":"双台乡","420323204":"楼台乡","420323205":"文峰乡","420323206":"深河乡","420323207":"柳林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420323.json
// module id = 1844
// module chunks = 0